import { getHeatColor, MunicipalitiesMap } from '@advanza/municipalityMap'
import { getRangeFromObject } from 'components/misc/misc'
import { useAppSelector } from 'hooks/hooks'
import { useMunicipalities } from 'hooks/municipalityHooks'
import React from 'react'
import ServiceStatsContainer from '../../containers/ServiceStatsContainer'

const ServiceCompetitionGraph = ({ getStatsAndOptions }) => {
    const {
        stats: { pros, nrPros, prosData: municipalityCounts },
    } = getStatsAndOptions('competitionStats')
    const country = useAppSelector((state) => state.countries.countries[0])
    const { range, min } = getRangeFromObject(municipalityCounts)
    const { municipalities } = useMunicipalities(country)
    const municipalityStyles = {}
    for (const key in municipalityCounts) {
        municipalityStyles[key] = {
            fillColor: getHeatColor((municipalityCounts[key] / (range + min)) * 100),
            fillOpacity: 0.5,
            strokeColor: getHeatColor((municipalityCounts[key] / (range + min)) * 100, true),
            strokeOpacity: 0.8,
        }
    }

    function getHoverContent(municipality) {
        const municipalityId = municipality.municipality_id
        if (!municipalityCounts[municipalityId]) {
            return '0'
        }

        return `<div>${municipality.name}</div>
        <b>${municipalityCounts[municipalityId]}</b> (${(
            (municipalityCounts[municipalityId] / nrPros) *
            100
        ).toFixed(2)}%)
            `
    }

    return (
        <div>
            <MunicipalitiesMap
                countryCode={country}
                municipalities={municipalities}
                height={country === 'NL' ? 600 : 375}
                width={country === 'NL' ? 500 : 600}
                key="coverage_pros"
                id="competition"
                onHoverMunicipality={(municipality) => {
                    return {
                        banner: getHoverContent(municipality),
                    }
                }}
                municipalityStyles={municipalityStyles}
                refreshTrigger={municipalityCounts}
            />
        </div>
    )
}

export default ServiceStatsContainer(ServiceCompetitionGraph)
